import { IFetchConfig } from "@elsa-zku/lib/helpers/fetch";
import fetch from "./http-client";

import { MeasureUnit } from "./data-contracts";

export const getAppMeasureunitGetallmeasureunits = (params?: IFetchConfig) =>
  fetch<MeasureUnit[]>("GET", `measure/unit`, null, params);
